import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import UserInfo from "@utils/UserInfo";
import PrepareDataTable from "./PrepareDataTable";
import { PurchaseOrderListContainer } from "./PurchaseOrderList.styled"
import AddEditPurchaseOrder from "../AddEditPurchaseOrder/AddEditPurchaseOrder";
import "./PurchaseOrderList.scss";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";

/**
 * Site List,
 * Path - /sites
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2979168257/Site+-+Purchase+orders)
 * @component
 */
const PurchaseOrderList = (props) => {
  const {
    t,
    columnList,
    entityId,
    countryId,
    page,
    siteName,
    siteOpportunityNumber,
    companyData,
  } = props;

  const [isAddPurchaseOrderPopupVisible, setAddPurchaseOrderPopupVisible] =
    useState(false);
  const [isRefreshList, setIsRefreshList] = useState(false);
  const [selectedCountryForFilter, setSelectedCountryForFilter] = useState([]);
  const generalParams = useGetGeneralParameters();
  const userCountryId = UserInfo.countryId();
  const countryList = UserInfo.countryListForFilter(t);

  const updateRefreshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewPurchaseOrder = () => {
    setAddPurchaseOrderPopupVisible(true);
  };
  const closePurchaseOrderCreationPopup = () => {
    setAddPurchaseOrderPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  useEffect(() => {
      const effectiveCountryId = userCountryId ?? countryId;
      const selectedCountry = countryList.find(
        (data) => data.value === effectiveCountryId
      );
      setSelectedCountryForFilter(selectedCountry);
    }, []);

  return (
    <PurchaseOrderListContainer className="purchaseOrder-list">
      {selectedCountryForFilter?.value &&
        Object.keys(generalParams)?.length > 0 && (
          <PrepareDataTable
            isRefreshList={isRefreshList}
            columnList={columnList}
            updateRefreshStatus={updateRefreshStatus}
            createNewPurchaseOrder={createNewPurchaseOrder}
            countryId={countryId}
            entityId={entityId}
            page={page}
            mainCountryInfo={selectedCountryForFilter}
            siteName={siteName}
            siteOpportunityNumber={siteOpportunityNumber}
            companyData={companyData}
          />
        )}
      {isAddPurchaseOrderPopupVisible && (
        <AddEditPurchaseOrder
          context={page}
          {...(page === "site"
            ? { siteId: entityId }
            : { companyId: entityId })}
          siteName={siteName}
          siteOpportunityNumber={siteOpportunityNumber}
          platformCountryId={countryId}
          onClose={closePurchaseOrderCreationPopup}
          updateRefreshStatus={updateRefreshStatus}
        />
      )}
    </PurchaseOrderListContainer>
  );
};

PurchaseOrderList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
  entityId: PropTypes.number.isRequired,
  countryId: PropTypes.number.isRequired,
  siteName: PropTypes.string,
  siteOpportunityNumber: PropTypes.string,
  companyData: PropTypes.object,
};

PurchaseOrderList.defaultProps = {
  columnList: [],
  entityId: null,
  countryId: null,
  siteName: "",
  siteOpportunityNumber: null,
  companyData: null,
};

export default withTranslation()(PurchaseOrderList);
